// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6fb21ae8","703":"de948838"}[chunkId] + ".chunk.js";
};